var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8897_43079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0604 8.8281C2.32565 8.6484 2.5 8.34445 2.5 8C2.5 7.44775 2.05225 7 1.5 7C0.94775 7 0.5 7.44775 0.5 8C0.5 8.3943 0.73035 8.7322 1.062 8.895C1.4016 11.562 3.2356 13.8189 5.8463 14.6624L6.15365 13.7107C3.9359 12.9944 2.37155 11.0876 2.0604 8.8281Z",
    fill: "#49A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6623 10.1553L13.7106 9.84766C12.9942 12.0654 11.0876 13.6299 8.8281 13.9409C8.6483 13.6758 8.3446 13.5015 8 13.5015C7.44775 13.5015 7 13.9492 7 14.5015C7 15.0537 7.44775 15.5015 8 15.5015C8.3944 15.5015 8.7322 15.2713 8.8949 14.9395C11.5619 14.5999 13.8188 12.7659 14.6623 10.1553Z",
    fill: "#49A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9383 7.10329C14.5987 4.43629 12.7647 2.17944 10.154 1.33594L9.84668 2.28759C12.0644 3.00389 13.6288 4.91064 13.9399 7.17014C13.6747 7.34984 13.5003 7.65379 13.5003 7.99824C13.5003 8.55049 13.9481 8.99824 14.5003 8.99824C15.0526 8.99824 15.5003 8.55049 15.5003 7.99824C15.5003 7.60394 15.2701 7.26609 14.9383 7.10329Z",
    fill: "#49A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 0.5C7.60584 0.5 7.26804 0.7302 7.10534 1.062C4.43834 1.4016 2.18139 3.2356 1.33789 5.8462L2.28954 6.1538C3.00599 3.93605 4.91259 2.37155 7.17209 2.06055C7.35189 2.3257 7.65559 2.5 8.00019 2.5C8.55244 2.5 9.00019 2.05225 9.00019 1.5C9.00019 0.94775 8.55249 0.5 8.00024 0.5Z",
    fill: "#49A3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8897_43079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunTestIcon);
export default __webpack_public_path__ + "static/media/RunTestIcon.d65022cf2cecd73042c6b31cc1af1ff3.svg";
export { ForwardRef as ReactComponent };